import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { uuidv7 } from '@vidmakr/shared';
import { Button, Card, Field, Input } from '@/components/ui';
import { reducers } from '@/lib/stdb';
import { attempt } from '@/lib/toast';
import { useOrgs } from '@/lib/hooks';
import { useSession } from '@/lib/session';

export function NewOrgPage() {
  const navigate = useNavigate();
  const user = useSession((s) => s.user);
  const { orgs } = useOrgs();
  const [name, setName] = useState(orgs.length === 0 && user?.name ? `${user.name.split(' ')[0]}'s team` : '');
  const [busy, setBusy] = useState(false);
  const create = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    const id = uuidv7();
    const ok = await attempt(() => reducers().createOrg({ id, name }));
    setBusy(false);
    if (ok) navigate(`/orgs/${id}`);
  };
  return (
    <div className="mx-auto max-w-md pt-12">
      <Card className="p-6">
        <div className="mb-5 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent/15 text-accent-2">
            <Building2 size={20} />
          </div>
          <div>
            <h1 className="text-lg font-semibold">{orgs.length === 0 ? 'Create your first organization' : 'New organization'}</h1>
            <p className="text-sm text-muted">Projects, assets and members live in an organization.</p>
          </div>
        </div>
        <form onSubmit={create} className="space-y-4">
          <Field label="Organization name">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Acme Studios" autoFocus required maxLength={80} />
          </Field>
          <Button variant="primary" className="w-full" loading={busy} type="submit">
            Create organization
          </Button>
        </form>
      </Card>
    </div>
  );
}
